import tokens from 'config/constants/tokens'
import { tryParseAmount } from 'state/swap/hooks'
import { useUserVvsBar } from 'state/xVvs/hooks'
import { Price } from 'vvs-sdk'

/**
 *
 * @returns xVVS : VVS rate
 */
const useXvvsRate = () => {
  const { barData } = useUserVvsBar()
  const { stakedBalance, totalSupply } = barData
  const currencyAmount0 = tryParseAmount(totalSupply.toString(), tokens.xvvs)
  const currencyAmount1 = tryParseAmount(stakedBalance.toString(), tokens.xvvs)
  return stakedBalance.gt(0) && totalSupply.gt(0)
    ? new Price(tokens.xvvs, tokens.xvvs, currencyAmount0.raw, currencyAmount1.raw)
    : new Price(tokens.xvvs, tokens.xvvs, '1', '1')
}

export default useXvvsRate
